let faker = require('faker');
faker.local = 'ja';
import Dummy from 'dummyjs';

/**
 * Return Boolean
 * @returns {Boolean}
 */
export const boolean = () => {
  return faker.random.boolean();
};

/**
 * Return Random number (integer)
 * @param {number} min
 * @param {number} max
 * @returns {number}
 */
export const number = (min = 0, max = 99999999) => {
  // ( 最大値 - 最小値 ) + 最小値;
  const diff = max - min;
  return Math.floor(Math.random() * diff) + min;
};

/**
 * Return Random string
 * @param {number} length - String length
 * @returns {string} - e.g.'iG7dl5dfs'
 */
export const string = length => {
  const S = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';

  return Array.from(Array(length))
    .map(() => S[Math.floor(Math.random() * S.length)])
    .join('');
};

/**
 * Return Random text
 * @param {number} min - Minimum string length
 * @param {number} max - Maximum string length
 * @returns {String} - e.g.'Enim sagittis condimentum'
 */
export const text = (min, max) => {
  if (!min && !max) {
    return Dummy.text();
  } else {
    if (!max) {
      return Dummy.text(min);
    } else {
      return Dummy.text(min, max);
    }
  }
};

/**
 * Pick one item from Array.
 * @param {Array} array
 * @returns {String}
 */
export const picker = array => {
  const arrLength = array.length;
  const number = Math.floor(Math.random() * arrLength);

  return array[number];
};

/**
 * Payer ID
 * @param {String} vendor
 * @returns {String}
 */
export const payerId = (vendor = 'aws') => {
  const ids = {
    // AWS should be 12 chars
    aws: ['payer1234567', 'payer0987654', 'payer5678901'],
  };

  return picker(ids[vendor]);
};

/**
 * Account ID
 * @param {String} vendor
 * @returns {String}
 */
export const accountId = (vendor = 'aws') => {
  const ids = {
    // AWS should be 12 chars
    aws: ['acc123456789', 'acc098765432', 'acc567890123'],
  };

  return picker(ids[vendor]);
};

/**
 * Account Name
 * @param {String} vendor
 * @returns {String}
 */
export const accountName = (vendor = 'aws') => {
  const ids = {
    aws: ['AccountAWS1', 'AccountAWS2', 'AccountAWS3'],
  };

  return picker(ids[vendor]);
};

/**
 * ID
 * @returns {String} - e.g. 22b4131e-d70e-459d-b499-505b88f21f7b
 */
export const id = () => {
  return faker.random.uuid();
};

/**
 * Email address
 * @returns {String}
 */
export const email = () => {
  return faker.internet.email();
};

export const url = () => {
  return faker.internet.url();
};
